jQuery.noConflict();
(function($) {
  $(function() {
    //.fadeinが画面に入ってきた時に.js-scrollinを付与する
    $(window).scroll(function() {
      $(".fadein").each(function() {
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > elemPos - windowHeight + 200) {
          $(this).addClass("js-scrollin");
        }
      });
    });
    // #で始まるアンカーをクリックした場合に処理
    $('a[href^="#"]').click(function() {
      var speed = 400; // ミリ秒
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top;
      $("body,html").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });
})(jQuery);
